import type { EditorCommandHost } from "@/editor/commands/editorCommandHost";

export function bindCommand<A extends unknown[], R>(
  host: EditorCommandHost,
  runner: (host: EditorCommandHost, ...args: A) => R,
): (...args: A) => R {
  return (...args) => runner(host, ...args);
}
